<template>
  <div class="space-between-y">

    <el-tabs v-model="client">
      <el-tab-pane label="园长端小程序" name="CUSTOMER"/>
      <el-tab-pane label="家长/游客端小程序" name="MIU"/>
    </el-tabs>

    <miu-list v-if="client === 'MIU'"></miu-list>
    <customer-list v-if="client === 'CUSTOMER'"></customer-list>

  </div>
</template>

<script>
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";
import MiuList from "@/components/user/MiuList.vue";
import CustomerList from "@/components/user/CustomerList.vue";

export default {
  name: 'WechatUserManage',
  components: {CustomerList, MiuList, LineOverflow},

  data() {
    return {
      client: "CUSTOMER",
      users: [],
    }
  },
};
</script>

<style scoped>
</style>
